<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="modern-card">
                    <div class="modern-card-body">
                        <div class="row">
                            <div class="col-md-6 col-sm-12 b-r pb-3">
                                <h5 class="section-title text-info mb-4">
                                    <i class="fas fa-route"></i> Crear ruta seleccionando las tiendas a visitar
                                </h5>
                                <div class="form-group row align-items-center mb-3" id="datForm">
                                    <label class="col-sm-2 col-form-label font-weight-bold">Fecha</label>
                                    <div class="col-sm-10">
                                        <date-picker v-model="time1" valueType="YYYY-MM-DD" type="week" class="w-100"></date-picker>
                                    </div>
                                </div>
                                <div class="form-group row align-items-center mb-4">
                                    <label class="col-sm-2 col-form-label font-weight-bold">Supervisor</label>
                                    <div class="col-sm-10">
                                        <gestores-component :placeholderm="'Supervisor'" v-on:cambioGestor="setGestor" ref="gestorSelect" class="w-100"></gestores-component>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <button class="btn btn-primary px-4 shadow-sm" type="button" @click="verRuta()">
                                        <i class="fas fa-search mr-1"></i> <strong>Ver ruta</strong>
                                    </button>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-12 pb-3">
                                <h5 class="section-title text-info mb-4">
                                    <i class="fas fa-file-upload"></i> Cargar archivo de rutas
                                </h5>
                                <div class="form-group row align-items-center mb-4">
                                    <label class="col-sm-2 col-form-label font-weight-bold">Archivo</label>
                                    <div class="col-sm-10">
                                        <div class="custom-file">
                                            <input type="file" id="archivo" name="archivo" class="custom-file-input" required="" ref="fileRutas" v-on:change="handleFileUpload()">
                                            <label class="custom-file-label text-truncate" for="archivo">
                                                {{ file ? file.name : 'Seleccionar archivo...' }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pt-2">
                                    <div class="col-md-6 mb-2">
                                        <button v-if="!loadfile" class="btn btn-primary btn-block shadow-sm" type="button" @click="submitFile()">
                                            <i class="fas fa-cloud-upload-alt mr-1"></i> <strong>Cargar archivo</strong>
                                        </button>
                                    </div>
                                    <div class="col-md-6 mb-2 text-right">
                                        <div v-if="loadfile" class="text-center">
                                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="30">
                                            <span class="ml-2 font-weight-bold text-muted small">Preparando archivo...</span>
                                        </div>
                                        <button v-if="!loadfile" class="btn btn-outline-primary btn-block shadow-sm" type="button" @click="ExportFile()">
                                            <i class="fas fa-download mr-1"></i> <strong>Descargar Layout</strong>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div class="row mt-4" v-if="show">
                <div class="col-md-4">
                    <div class="modern-card">
                        <div class="modern-card-header">
                            <h5 class="section-title"><i class="fas fa-store"></i> Agregar tienda a ruta</h5>
                        </div>
                        <div class="modern-card-body">
                            <div class="alert alert-outline-info p-2 mb-4" role="alert" style="border-radius: 8px;">
                                <small class="text-info">
                                    <i class="fas fa-info-circle mr-1"></i> Completa los datos correctamente. Los campos marcados con <b class="text-danger">(*)</b> son obligatorios.
                                </small>
                            </div>
                            
                            <div class="form-group mb-3">
                                <label class="font-weight-bold mb-1">Fecha <b class="text-danger">(*)</b></label>
                                <v-select :multiple="false" :options="optionsFechas" :placeholder="'Selecciona Fecha De Ruta'" v-model="selectedFecha"></v-select>
                            </div>
                            
                            <div class="form-group mb-3">
                                <label class="font-weight-bold mb-1">Cadena <b class="text-danger">(*)</b></label>
                                <cadenas-component :placeholderm="'Cadena'" v-on:cambioCadena="getFormatos" ref="cadenaTienda"></cadenas-component>
                            </div>
                            
                            <div class="form-group mb-3">
                                <label class="font-weight-bold mb-1">Formato <b class="text-danger">(*)</b></label>
                                <formatos-component :placeholderm="'Formato'" v-on:cambioFormato="getTiendas" ref="formatoTienda"></formatos-component>
                            </div>
                            
                            <div class="form-group mb-4">
                                <label class="font-weight-bold mb-1">Tienda <b class="text-danger">(*)</b></label>
                                <tiendasmain-component :placeholderm="'Tienda'" ref="tiendaTienda"></tiendasmain-component>
                            </div>
                            
                            <button class="btn btn-success btn-block shadow-sm" type="button" @click="saveRuta()">
                                <i class="fas fa-save mr-1"></i> <strong>Guardar tienda</strong>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-8">
                    <div class="modern-card">
                        <div class="modern-card-header d-flex justify-content-between align-items-center">
                            <h5 class="section-title"><i class="fas fa-map-marked-alt"></i> Listado de Rutas</h5>
                            <span class="badge badge-pill badge-primary px-3 py-2 font-weight-bold shadow-sm" style="font-size: 0.85rem;">
                                <i class="fas fa-user-tie mr-1"></i> {{ nombre }} ({{ ciudad }} - {{ agencia }})
                            </span>
                        </div>
                        <div class="modern-card-body p-0">
                            <div class="table-responsive p-3">
                                <v-client-table :data="tableDataRuta" :columns="columnsRuta" :options="optionsRuta" class="table table-hover table-striped mb-0">
                                    <div slot="Opciones" slot-scope="props">
                                        <h5 v-if="props.row.FechaPasada && props.row.Estatus === 'Pendiente'" class="m-0">
                                            <i data-placement="top" data-toggle="tooltip-primary" title="Eliminar" class="fas fa-trash text-danger action-icon" @click="EliminarRuta(props.row.Id)"></i>
                                        </h5>
                                        <h5 v-if="!props.row.FechaPasada && (props.row.Estatus === 'Pendiente' || props.row.Estatus === 'En Proceso')" class="m-0">
                                            <i data-placement="top" data-toggle="tooltip-primary" title="Eliminar" class="fas fa-trash text-danger action-icon" @click="EliminarRuta(props.row.Id)"></i>
                                        </h5>
                                    </div>
                                    <div slot="Estatus" slot-scope="props">
                                        <div v-show="!props.row.EditEstatus" class="text-center">
                                            <span :class="getStatusBadgeClass(props.row.Estatus)">{{props.row.Estatus}}</span>
                                            
                                            <!-- Edit icon for Visitada routes to allow generic manual override -->
                                            <span v-if="props.row.Estatus === 'Visitada'" class="ml-1">
                                                <i class="fas fa-edit text-muted edit-status-icon" title="Editar Estatus" @click="editaEstatus(props.row.Id)"></i>
                                            </span>

                                            <!-- Direct change option for past En Proceso routes to reset them to Pendiente -->
                                            <div v-if="!props.row.FechaPasada && props.row.Estatus === 'En Proceso'" class="mt-1">
                                                <button class="btn btn-xs btn-outline-warning shadow-sm font-weight-bold" @click="updateRutaEstatus(props.row.Id, 'Pendiente')" style="font-size: 10px; padding: 2px 6px;">
                                                    <i class="fas fa-undo"></i> Mandar a Pendiente
                                                </button>
                                            </div>
                                        </div>
                                        <div v-show="props.row.EditEstatus" class="text-center d-flex align-items-center justify-content-center">
                                            <select class="form-control form-control-sm select-status-edit" v-model="props.row.Estatus" @change="saveEstatusDirect(props.row)">
                                                <option value="Visitada">Visitada</option>
                                                <option value="En Proceso">En Proceso</option>
                                                <option value="Pendiente">Pendiente</option>
                                                <option value="Cancelada">Cancelada</option>
                                                <option value="No se pudo visitar">No se pudo visitar</option>
                                                <option value="No visitada">No visitada</option>
                                            </select>
                                            <button class="btn btn-xs btn-default ml-1" @click="cancelaEstatus(props.row.Id)" title="Cancelar">
                                                <i class="fas fa-times text-danger"></i>
                                            </button>
                                        </div>
                                    </div>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "mainr",
    data(){
        return{
            file: '',
            time1:null,
            today:null,
            supervisor:null,
            selectedFecha:null,
            show: false,
            columnsRuta: ['Id','Dia','Fecha','KCMID','Cadena','Formato','Tienda','Entrada','Salida','Tiempo','Estatus','Motivo','Opciones'],
            tableDataRuta: [],
            optionsFechas: [],
            optionsRuta: {
                alwaysShowPerPageSelect: false,
                footerHeadings: true,
                perPage: 10,
                filterable: ['Dia'],
                filterByColumn: true,
                listColumns: {
                    Dia: [
                        { id: 'Lunes', text: 'Lunes' },
                        { id: 'Martes', text: 'Martes' },
                        { id: 'Miércoles', text: 'Miércoles' },
                        { id: 'Jueves', text: 'Jueves' },
                        { id: 'Viernes', text: 'Viernes' },
                        { id: 'Sábado', text: 'Sábado' },
                        { id: 'Domingo', text: 'Domingo' },
                    ],
                },
                headings: {
                    Id: '#',
                    KCMID: 'IDTIENDA',
                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Nombre: 'text-center',
                    Agencia: 'text-center',
                    Ciudad: 'text-center',
                    Opciones: 'text-center',
                    Area: 'text-center',
                    Tienda: 'text-justify',
                    KCMID: 'text-center font-bold',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar por {column}",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    columns: 'Columnas'
                },
            },
            nombre:'',
            agencia:'',
            ciudad:'',
            loadfile:false,
            validateFecha:false,
        }
    },
    mounted() {
        this.time1 = moment().format('YYYY-MM-DD');
        this.today = moment().format('YYYY-MM-DD');
    },

    methods:{
        editaEstatus(key){
            var idx = this.tableDataRuta.findIndex(data => data.Id === key);
            this.tableDataRuta[idx].EditEstatus = true;
        },
        cancelaEstatus(key){
            var idx = this.tableDataRuta.findIndex(data => data.Id === key);
            this.tableDataRuta[idx].EditEstatus = false;
        },
        handleFileUpload(){
            this.file = this.$refs.fileRutas.files[0];
        },
        submitFile(){ let $this = this;
            if (this.file === ''){
                $this.$toastMessage('error','Seleccione un archivo CSV para procesar',4000,'center');
            }
            else{
                this.loadfile = true;
                let formData = new FormData();
                formData.append('file', this.file);
                axios.post( '/api/Main/importRutasLayout',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(r){
                    if (r.data.Success){
                        $this.$swal.fire({
                            icon: 'success',
                            title: 'ÉXITO',
                            text: 'archivo procesado correctamente!',
                            footer: '<b>' + r.data.Mensaje + '</b>'
                        });
                    }else{
                        $this.$swal.fire({
                            icon: 'error',
                            title: 'Error!',
                            text: 'Archivo procesado con errores!',
                            footer: '<b>' + r.data.Mensaje + '</b>'
                        });
                    }
                    $this.file = '';$this.loadfile = false;$this.$refs.fileRutas.value = null;
                })
                .catch(function(){
                    console.log('FAILURE!!');
                    $this.$toastMessage('error','Error no definido, reportar a IT',4000,'center');
                    $this.file = '';$this.loadfile = false;$this.$refs.fileRutas.value = null;
                });
            }

        },
        EliminarRuta(cve){ let $this = this;
            this.$swal.fire({
                title: '¿Eliminar Ruta?',
                text: 'Esto eliminara la visita a la tienda',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/Main/deleRuta',{delete:cve})
                    .then(function (r){
                        if (r.data.Success){
                            $this.verRuta();
                            $this.$toastMessage('success',r.data.Mensaje,3000,'top-right');
                        }
                        else{
                            $this.$toastMessage('error',r.data.Mensaje,3000,'top-right');
                        }
                    });
                }
            });
        },
        saveRuta(){ let $this = this;
            var a = this.$refs.tiendaTienda.selectedTiendas;
            if (a == null){
                this.$toastMessage('error',"Seleccione la tienda para guardar la ruta!",3000,'top-right');
            }
            else if (this.selectedFecha === null){
                this.$toastMessage('error',"Seleccione la fecha de la ruta para guardar la ruta!",3000,'top-right');
            }
            else{
                axios
                    .post('/api/Main/saveRuta',{fecha:this.selectedFecha.value,usuario:this.supervisor,tienda:a.value})
                    .then(function (r){
                        if (r.data.Success){
                            $this.$refs.tiendaTienda.optionsTiendas = [];
                            $this.$refs.tiendaTienda.selectedTiendas = null;
                            $this.$refs.tiendaTienda.optionsCadenas = [];
                            $this.$refs.cadenaTienda.selectedCadenas = null;
                            $this.$refs.formatoTienda.optionsFormatos = [];
                            $this.$refs.formatoTienda.selectedFormatos = null;
                            $this.verRuta();
                            $this.$toastMessage('success',r.data.Mensaje,3000,'top-right');
                        }
                        else{
                            $this.$toastMessage('error',r.data.Mensaje,3000,'top-right');
                        }

                    });
            }
        },
        setGestor(){
            if (this.$refs.gestorSelect.selectedGestores !== null){
                this.supervisor = this.$refs.gestorSelect.selectedGestores.value;
            }
            else{
                this.supervisor = null;
                this.show=false;
            }

        },
        verRuta(){ let $this = this;
            if (this.time1 === null){
                $this.$toastMessage('error',"Seleccione la semana de la ruta!",3000,'top-right');
            }
            else if (this.supervisor === null){
                $this.$toastMessage('error',"Seleccione el supervisor, para ver su ruta",3000,'top-right')
            }
            else{
                this.optionsFechas = [];
                axios
                    .post('/api/Main/getRutas',{fecha:this.time1,usuario:this.supervisor})
                    .then(function (r){
                        $this.tableDataRuta = r.data.Data;
                        $this.nombre = r.data.Nombre;
                        $this.agencia = r.data.Agencia;
                        $this.ciudad = r.data.Ciudad;
                        $this.optionsFechas = r.data.Fechas;
                        if (!$this.show){$this.show=true}

                        var dateA = moment($this.time1);
                        var dateB = moment($this.today);
                        $this.validateFecha = (dateA.diff(dateB) >= 0);
                    });

            }

        },
        getFormatos(){
            var a = this.$refs.cadenaTienda.selectedCadenas;
            if (a !== null){
                this.$refs.formatoTienda.cvecadena = a.value;
                this.$refs.formatoTienda.optionsFormatos = [];
                this.$refs.formatoTienda.getDataFormatos();
            }else{
                this.$refs.formatoTienda.optionsFormatos = [];
                this.$refs.formatoTienda.selectedFormatos = null;
                this.$refs.tiendaTienda.selectedTiendas = null;
                this.$refs.tiendaTienda.optionsTiendas = [];
            }
        },
        getTiendas(){
            var a = this.$refs.formatoTienda.selectedFormatos;
            if (a !== null){
                this.$refs.tiendaTienda.cveentfmt = a.value;
                this.$refs.tiendaTienda.optionsTiendas = [];
                this.$refs.tiendaTienda.getTiendas();
            }else{
                this.$refs.tiendaTienda.selectedTiendas = null;
                this.$refs.tiendaTienda.optionsTiendas = [];
            }
        },
        ExportFile(){let $this = this;
            this.loadfile = true;
            axios({
                method: 'post',
                url: '/api/Main/exportLayoutToExcel',
                responseType: 'arraybuffer',
                data: {typeUsers: this.typeUsers}}).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'LayoutTrabajo.xlsx'
                    link.click()
                    $this.loadfile=false;
                },
                error => {$this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');}
            );
        },
        getStatusBadgeClass(status) {
            if (!status) return 'badge-status-secondary';
            switch (status) {
                case 'Visitada':
                    return 'badge-status-success';
                case 'En Proceso':
                    return 'badge-status-warning';
                case 'Pendiente':
                    return 'badge-status-info';
                case 'Cancelada':
                    return 'badge-status-danger';
                case 'No se pudo visitar':
                    return 'badge-status-danger-outline';
                case 'No visitada':
                    return 'badge-status-dark';
                default:
                    return 'badge-status-secondary';
            }
        },
        updateRutaEstatus(cve, nuevoEstatus) {
            let $this = this;
            this.$swal.fire({
                title: '¿Cambiar estatus a Pendiente?',
                text: 'Esto restablecerá la ruta a estatus Pendiente y borrará las horas de entrada/salida si las hubiera.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#f8c86c',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, cambiar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/Main/changeEstatus', { id: cve, estatus: nuevoEstatus })
                        .then(function (r) {
                            if (r.data.Success) {
                                $this.verRuta();
                                $this.$toastMessage('success', r.data.Mensaje, 3000, 'top-right');
                            } else {
                                $this.$toastMessage('error', r.data.Mensaje, 3000, 'top-right');
                            }
                        })
                        .catch(function (error) {
                            console.error(error);
                            $this.$toastMessage('error', 'Error al cambiar estatus', 3000, 'top-right');
                        });
                }
            });
        },
        saveEstatusDirect(row) {
            let $this = this;
            axios.post('/api/Main/changeEstatus', { id: row.Id, estatus: row.Estatus })
                .then(function (r) {
                    if (r.data.Success) {
                        row.EditEstatus = false;
                        $this.verRuta();
                        $this.$toastMessage('success', r.data.Mensaje, 3000, 'top-right');
                    } else {
                        $this.$toastMessage('error', r.data.Mensaje, 3000, 'top-right');
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    $this.$toastMessage('error', 'Error al actualizar estatus', 3000, 'top-right');
                });
        },
    }
}
</script>

<style scoped>
.modern-card {
    background: #ffffff;
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.05);
    margin-bottom: 24px;
    transition: all 0.3s ease;
}
.modern-card:hover {
    box-shadow: 0 6px 26px rgba(0,0,0,0.08);
}
.modern-card-header {
    background: transparent;
    border-bottom: 1px solid #f1f5f9;
    padding: 16px 24px;
}
.modern-card-body {
    padding: 24px;
}
.section-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0;
    display: flex;
    align-items: center;
}
.section-title i {
    margin-right: 8px;
    color: #3b82f6;
}
.action-icon {
    font-size: 16px;
    cursor: pointer;
    transition: transform 0.2s ease, color 0.2s ease;
}
.action-icon:hover {
    transform: scale(1.15);
}
.edit-status-icon {
    cursor: pointer;
    font-size: 13px;
    transition: color 0.2s ease;
}
.edit-status-icon:hover {
    color: #3b82f6 !important;
}
.select-status-edit {
    width: auto !important;
    display: inline-block !important;
    font-size: 12px;
    height: 28px;
    padding: 2px 6px;
    border-radius: 6px;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to {
    opacity: 0
}

/* Beautiful custom status badges (using modern soft theme colors) */
.badge-status-success {
    background-color: #d4edda !important;
    color: #155724 !important;
    border: 1px solid #c3e6cb;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
.badge-status-warning {
    background-color: #fff3cd !important;
    color: #856404 !important;
    border: 1px solid #ffeeba;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
.badge-status-info {
    background-color: #cce5ff !important;
    color: #004085 !important;
    border: 1px solid #b8daff;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
.badge-status-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
    border: 1px solid #f5c6cb;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
.badge-status-danger-outline {
    background-color: #ffffff !important;
    color: #dc3545 !important;
    border: 1px solid #dc3545;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
.badge-status-dark {
    background-color: #e2e3e5 !important;
    color: #383d41 !important;
    border: 1px solid #d6d8db;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
.badge-status-secondary {
    background-color: #f8f9fa !important;
    color: #6c757d !important;
    border: 1px solid #dee2e6;
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 30px;
    font-weight: 600;
    display: inline-block;
}
</style>
